import { styled } from "@mui/material";
import { getProfileQuestionnairePaperPadding } from "../utils/get-profile-questionnaire-paper-padding.es.js";
import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
import Paper from "../../../../node_modules/@mui/material/Paper/Paper.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { Secondary, Common } from "../../../foundations/palette.es.js";
const ProfileQuestionnairePaper = styled(Paper, styledOptions)((args) => {
  const padding = getProfileQuestionnairePaperPadding(args);
  return {
    display: Displaying.flex,
    justifyContent: Alignment.spaceBetween,
    alignItems: Alignment.center,
    padding,
    borderRadius: 0,
    background: args.isActive ? Secondary.light : Common.white.main,
    "& div": {
      display: Displaying.inherit,
      alignItems: Displaying.inherit
    }
  };
});
export {
  ProfileQuestionnairePaper
};
//# sourceMappingURL=profile-questionnaire-paper.es.js.map
